import { BASE_URL } from "config";
import { api } from "utils";
import * as base from '../base';


const endpoints = {
  list: `${BASE_URL}/api/v1/seo/extlinkpage/`,
};

export const seoExtLinkPageListLoad = (token, payload) => api.ListLoad(endpoints.list, token, payload);

export const seoExtLinkPage = {
  state: {
    ...base.ListState,

    title: 'Внешние ссылки: страницы',
    urls: {
      list: (seoExtDomain) => `/extlink/${seoExtDomain}/pages`,
    },
  },
  reducers: {
    ...base.ListReducers,
  },
  effects: dispatch => ({
    async listLoad(payload, rootState) {
      await base.asyncListLoadRequest(dispatch, payload, rootState, 'seoExtLinkPage', seoExtLinkPageListLoad)
    },
  }),
}